import React from 'react'
import { IconButton, Input } from '@shopflo/ui'
import { X } from '@phosphor-icons/react'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import { useEntitledProducts } from '../../../hooks/useEntitledProducts'
import { DiscountApplyToType, BxgyEntitlement } from 'src/lib/types/discountsV2'
import FormErrorText from 'src/components/common/FormErrorText'
import CatalogueGroupControl from '../common/CatalogueGroupControl'
import { discountCatalogueErrors } from 'src/lib/utils/catalogueErrorHelpers'

const FreebieProductsList = () => {
  const {
    state: { entitlement: rawEntitlement, errors },
    actions: { setFormState }
  } = useDiscountForm()

  const entitlement = rawEntitlement as BxgyEntitlement

  const { entitledCatalogue, metaData } = entitlement

  const items = metaData?.entitledCatalogue || []

  const catalogueType =
    entitlement.applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS ? 'COLLECTION' : 'PRODUCT_AND_VARIANT'

  const {
    handleItemsSelected,
    handleRemoveGroup,
    handleRemoveIncludedItem,
    handleRemoveExcludedItem,
    handleQuantityChange,
    handleAddEmptyGroup,
    handleVariantUpdate
  } = useEntitledProducts({
    entitlement,
    setFormState,
    catalogueType
  })

  const renderList = () => {
    const displayGroups = items.length > 0 ? items : [[]]
    return (
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-4'>
          {displayGroups.map((group, groupIndex) => {
            return (
              <div key={groupIndex}>
                <div className='rounded-xl flex flex-col gap-3'>
                  {group.length > 0 && (
                    <div className='flex justify-between items-start pt-3'>
                      <div className='flex items-center gap-2'>
                        <span className='text-text-xs-regular text-zinc-500'>Min Qty</span>
                        <div className='min-w-10 max-w-fit'>
                          <Input
                            value={entitledCatalogue[groupIndex]?.quantity?.toString() ?? ''}
                            onChange={e => handleQuantityChange(groupIndex, e.target.value)}
                            dimension='sm'
                            type='number'
                            variant='filled'
                            className='min-w-10 text-center px-1'
                            style={{
                              width: `${(entitledCatalogue[groupIndex]?.quantity?.toString().length || 0) + 2}ch`
                            }}
                          />
                        </div>
                        <span className='text-text-xs-regular text-zinc-500'>quantity</span>
                      </div>
                      <div className='flex items-center gap-2'>
                        <span className='text-text-xs-medium text-zinc-500'>Group {groupIndex + 1}</span>
                        {groupIndex !== 0 && (
                          <IconButton
                            onClick={() => handleRemoveGroup(groupIndex)}
                            variant='ghost'
                            size='xs'
                            IconComponent={X}
                            className='text-zinc-500'
                          />
                        )}
                      </div>
                    </div>
                  )}

                  <CatalogueGroupControl
                    groupIndex={groupIndex}
                    includedGroups={items}
                    excludedGroups={metaData?.excludedCatalogue}
                    catalogueType={catalogueType}
                    actions={{
                      onRemoveIncludedItem: handleRemoveIncludedItem,
                      onRemoveExcludedItem: handleRemoveExcludedItem,
                      onUpdateItem: handleVariantUpdate,
                      onItemsSelected: handleItemsSelected,
                      onAddEmptyGroup: handleAddEmptyGroup
                    }}
                    errorHandling={{
                      errors: discountCatalogueErrors(errors, 'entitlement.entitledCatalogue')
                    }}
                    config={{
                      showVariantEditor: true,
                      addText: 'Add product',
                      showExclusionOption: true,
                      emptyText: catalogueType === 'COLLECTION' ? 'Choose Collections' : 'Choose Products'
                    }}
                  />
                </div>
                {groupIndex < items.length - 1 && <div className='h-[1px] w-full bg-zinc-200 mt-3' />}
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <div className='flex w-full mb-3'>
      <div className='border-l-1 border-zinc-200 w-5 rounded-l-lg border-y-1 h-auto'></div>
      <div className='flex flex-col gap-2 rounded-lg px-2 w-full'>
        {renderList()}
        <FormErrorText message={errors['entitlement.entitledCatalogue']} />
      </div>
      <div className='border-r-1 border-zinc-200 w-5 rounded-r-lg border-y-1  h-auto'></div>
    </div>
  )
}

export default FreebieProductsList
